import { useState, useRef } from 'react';

import {
    Box,
    Button,
    Text,
    Input,
    Divider,
    useDisclosure,
    Menu,
    MenuList,
    MenuItem
} from '@chakra-ui/react';

import Const from '../Constants';

const SideBarButton = ({
    id,
    dataTour,
    current,
    icon,
    title,
    background,
    action,
    editable = false,
    menuEnabled,
    menuItems,
    group,
    onSetGroup,
    onToNewGroup,
    menuDeleteEnabled,
    menuDeleteAction,
    menuRenameEnabled,
    menuRenameAction,
    menuGroupEnabled
  }) => {
    // Open states for the menu
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });

    const [titleState, settTitleState] = useState(title);
    const [isEditing, setIsEditing] = useState(false);

    const inputRef = useRef(null);

    const handleRightClick = (event) => {
        event.preventDefault(); // Prevent the default right-click menu
        setMenuPosition({ x: event.clientX, y: event.clientY });
        onOpen();
      };

    const handleBlur = async (event) => {
        if(title !== titleState) { // TODO handle the empty case as well
            menuRenameAction(id, titleState);
        }
    };

    return (
        <>
            <Button
                data-tour={dataTour}
                leftIcon={
                    <Box color={current === true ? Const.Orange400 : Const.White}>
                        {icon}
                    </Box>
                }
                size={Const.SM}
                height={'30px'}
                minH={'30px'}
                width={'100%'}
                background={ current === true ? Const.Gray69 : (background ? background : Const.Gray46) }
                color={current === true ? Const.Orange400 : Const.White}
                justifyContent={'flex-start'}
                _hover={{ background: Const.Gray69 }}
                onClick={action}
                onContextMenu={menuEnabled ? handleRightClick : null}
            >
                { !editable ?
                <Box
                    as={'span'}
                    whiteSpace={'nowrap'}
                    overflow={'hidden'}
                    textOverflow={'ellipsis'}
                    maxW={'100%'} // Ensure the text respects the button's width
                    >
                    { title }
                </Box>
                :
                <Input
                    ref={inputRef}
                    value={titleState}    
                    isReadOnly={!isEditing}
                    height={'30px'}
                    w={'100%'}
                    fontSize={Const.SM}
                    fontWeight={Const.Bold}
                    textAlign={Const.Left}
                    color={Const.White}
                    border={Const.sNone}
                    whiteSpace={'nowrap'}
                    overflow={'hidden'}
                    textOverflow={'ellipsis'}
                    borderWidth={0}
                    padding={0}
                    maxW={'100%'}
                    background="transparent"
                    _focus={{
                        background: 'transparent',
                        boxShadow: 'none',
                        outline: 'none',
                    }}
                    _hover={{
                        background: 'transparent',
                    }}
                    style={{ cursor: Const.sDefault }}
                    onChange={(event) => {
                        settTitleState(event.target.value);
                    }}
                    onBlur={(event) => {
                        setIsEditing(false);
                        handleBlur(event);
                    }}
                />
                }
            </Button>

            {isOpen && (
            <Menu isOpen={isOpen} onClose={onClose}>
            <MenuList
                background={Const.Gray46}
                borderColor={Const.Gray64}
                style={{
                position: 'absolute',
                top: `${menuPosition.y}px`,
                left: `${menuPosition.x}px`
                }}
            >
                { menuGroupEnabled &&
                <Text
                    fontSize={Const.SM}
                    fontWeight={Const.Bold}
                    color={Const.Gray180}
                    paddingLeft={2}
                    background={Const.Gray46}
                    textAlign={Const.Left}
                    cursor={Const.sDefault}
                >
                    Move to
                </Text>
                }
                {
                    menuItems && menuItems.map((item, index) => (
                        group !== item && <MenuItem
                            key={index}
                            color={Const.White}
                            background={Const.Gray46}
                            fontSize={Const.SM}
                            _hover={{ background: Const.Gray64 }}
                            onClick={() => onSetGroup(id, item) }
                        >
                            { item }
                        </MenuItem>
                    ))
                }

                {/* Divider */}
                { menuGroupEnabled && <Divider borderColor={Const.Gray100} /> }

                { menuGroupEnabled &&
                <MenuItem
                    color={Const.Green500}
                    fontWeight="bold"
                    background={Const.Gray46}
                    fontSize={Const.SM}
                    onClick={() => onToNewGroup(id)}
                    _hover={{ background: Const.Gray64 }}
                >
                    + new group
                </MenuItem>
                }

                { menuRenameEnabled && 
                <MenuItem
                    color={Const.White}
                    fontWeight="bold"
                    background={Const.Gray46}
                    fontSize={Const.SM}
                    onClick={() => {
                        setIsEditing(true);
                        setTimeout(() => {
                            if (inputRef.current) {
                                inputRef.current.focus();
                                inputRef.current.setSelectionRange(titleState.length, titleState.length); // Move cursor to end
                            }
                        }, 10); // Somehow works better than 0
                    }}
                    _hover={{ background: Const.Gray64 }}
                >
                    Rename
                </MenuItem>
                }

                { menuDeleteEnabled && 
                <MenuItem
                    color={Const.Red500}
                    fontWeight="bold"
                    background={Const.Gray46}
                    fontSize={Const.SM}
                    onClick={() => {
                        menuDeleteAction(id);
                    }}
                    _hover={{ background: Const.Gray64 }}
                >
                    Delete
                </MenuItem>
                }

            </MenuList>
            </Menu>
        )}
        </>
    );
};

export default SideBarButton;

